import styled from 'styled-components'
import { Topline } from '@components/Typography'

export default styled(Topline)`
  text-align: center;
`
